
import OperationLogList from './src/OperationLog/OperationLogList.vue' //操作日志列表
import OperationLogDetail from './src/OperationLog/OperationLogDetail.vue' //操作日志详情 
import ErrorLogList from './src/ErrorLog/ErrorLogList.vue' //错误日志列表
import ErrorLogDetail from './src/ErrorLog/ErrorLogDetail.vue' //错误日志详情 

let views = {
  OperationLogList,
  OperationLogDetail,
  ErrorLogList,
  ErrorLogDetail
};

export default views;